'use client';

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useWorkflowStore } from '../../../stores/workflowStore';
import { MultiColumnSelector } from '../ColumnSelector';
import { useNodeInputColumns } from '../../../hooks/useNodeInputs';
import { Info } from '@phosphor-icons/react';

interface GroupByConfigProps {
  nodeId: string;
  config: { groupBy?: string[] };
}

export function GroupByConfig({ nodeId, config }: GroupByConfigProps) {
  const { t } = useTranslation();
  const { updateNodeConfig } = useWorkflowStore();
  const [groupBy, setGroupBy] = useState<string[]>(config.groupBy || []);
  const inputColumns = useNodeInputColumns(nodeId);

  // 当 config 变化时（如 AI 生成工作流后），同步更新内部状态
  useEffect(() => {
    if (config.groupBy) {
      setGroupBy(config.groupBy);
    }
  }, [config.groupBy]);

  const handleChange = (cols: string[]) => {
    setGroupBy(cols);
    updateNodeConfig(nodeId, { type: 'group_by', params: { groupBy: cols } });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <label className="text-xs font-medium text-zinc-500">{t('nodes.config.group_by.groupColumns')}</label>
        <MultiColumnSelector values={groupBy} onChange={handleChange} columns={inputColumns ?? []} />
      </div>
      <div className="flex items-start gap-2 p-3 bg-blue-50 rounded-xl border border-blue-100">
        <Info className="w-4 h-4 text-blue-500 flex-shrink-0 mt-0.5" />
        <div className="space-y-1">
          <p className="text-xs text-blue-700 font-medium">
            {t('nodes.config.group_by.aggregations')}
          </p>
          <p className="text-xs text-blue-600">
            {t('nodes.config.group_by.groupHint')}
          </p>
        </div>
      </div>
    </div>
  );
}
